<template>
  <layout name="Notification">
    <VSystemMessage primaryText="Forgot your password?">
      <div class="forgot-wrapper">
        <h3>Enter your email address</h3>
        <ForgotPasswordForm></ForgotPasswordForm></div
    ></VSystemMessage>
  </layout>
</template>

<script>
import Vue from "vue";
import Layout from "@/layouts/Layout";
import ForgotPasswordForm from "@/components/ForgotPasswordForm.vue";
import VSystemMessage from "@/components/VSystemMessage";

export default Vue.component("ForgotPassword", {
  metaInfo: {
    title: "Forgot Password"
  },

  components: {
    ForgotPasswordForm,
    Layout,
    VSystemMessage
  }
});
</script>

<style lang="scss" scoped>
h3 {
  font-size: 16px;
  color: $secondary-text-color;
  text-align: center;
  margin-bottom: 20px;
  margin-top: 30px;
}
.forgot-wrapper {
  margin: auto;
  max-width: 70%;
}

/deep/ .v-system-message__title {
  font-size: 24px;
  color: $main-text-color;
}
</style>

<style>


@media screen and (max-width: 600px) {
  .forgot-wrapper {
    max-width: 90%;
    padding: 0;
  }
}
</style>
